<template>
  <div class="channels-filters" v-if="showGroup">
    <h5>{{ title }}</h5>
    <div class="channels-scroll" :class="{ 'long-group': isLong, 'short-group': !isLong }">
      <el-collapse style="border-top: none" accordion>
        <el-collapse-item
          v-for="(channelOptions, channelType) in groupedChannelOptions"
          :key="channelType"
          :name="channelType"
        >
          <template slot="title">
            <span class="collapse-title">{{ channelType.toUpperCase() }}</span>
          </template>

          <div>
            <el-checkbox-group v-model="selectedOptions" @change="handleChange">
              <div v-for="option in channelOptions" :key="option.id">
                <el-checkbox :label="option.id">
                  <social-icon class="fa fa-fw" :type="capitalize(option.type)" />
                  <span class="option">{{ option.handle }}</span>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import SocialIcon from '@/components/common/Icons/SocialIcon';
import { isEmpty, capitalize, get } from 'lodash';

export default {
  name: 'ChannelsFilter',
  components: { SocialIcon },

  props: {
    title: { type: String, required: true },
    path: { type: String, required: true },
    options: { type: Array, default: () => [] },
    valueKey: { type: String, default: null },
    labelKey: { type: String, default: null },
    virtualListSize: { type: Number, default: 2 },
    virtualListVisible: { type: Number, default: 12 },
    isLong: { type: Boolean, default: false },
  },

  data: () => ({
    selectedOptions: [],
  }),

  computed: {
    groupedChannelOptions() {
      const grouped = this.options.reduce((acc, channel) => {
        const channelType = channel.type;
        if (!acc[channelType]) acc[channelType] = [];
        acc[channelType].push(channel);
        return acc;
      }, {});

      const sortedGrouped = {};
      Object.keys(grouped)
        .sort((a, b) => a.localeCompare(b))
        .forEach(type => {
          sortedGrouped[type] = grouped[type].sort((a, b) => a.handle.localeCompare(b.handle));
        });

      return sortedGrouped;
    },

    selectedByGroup() {
      const grouped = {};
      Object.keys(this.groupedChannelOptions).forEach(type => {
        grouped[type] = this.groupedChannelOptions[type]
          .filter(opt => this.selectedOptions.includes(opt.id))
          .map(opt => opt.id);
      });
      return grouped;
    },

    showGroup() {
      return !isEmpty(this.options);
    },
  },

  methods: {
    capitalize,
    handleChange() {
      this.$emit('change', [this.path, this.selectedOptions]);
    },
    reset() {
      this.selectedOptions = [];
      this.handleChange();
    },
    apply(filter) {
      const options = get(filter, this.path, []);
      this.selectedOptions = options;
    },
  },
};
</script>

<style scoped>
h5 {
  color: #c2c5cc;
}

.collapse-title {
  font-size: 0.9em;
  color: #676a6c;
  font-weight: 600;
}

.group-item {
  margin-left: 16px;
  margin-bottom: 4px;
}

.option {
  font-size: 0.9em;
}

.scrollable-container {
  margin-bottom: 5px;
}

.channels-scroll {
  display: block;
}

.long-group {
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 10px;
  margin-right: 4px;
}

.short-group {
  height: 180px;
  overflow-y: hidden;
  overflow-x: hidden;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// ChannelsFilter.vue?1ad5a75a